<div class="container mt-5 mb-5 card p-3">
  <!-- Start Filter -->
  <div class="">
    <div class="row">
      <div class="col-md-6">
        <h1 class="bold primary"><i class="fas fa-users"></i> {{ "group-classes" | translate }} </h1>
      </div>
      <div class="col-md-6">
        <a class=" float-right"
          [routerLink]="['/teacher/group-classes/create']">

          <button class="btn btn-primary"
          ><i class="fas fa-folder-plus"></i> {{ "create-group-class" | translate }} </button></a
        >
      </div>
      <div class="col-md-12 pt-3">
        {{ "group-classes-teacher-info" | translate }}
      </div>
    </div>
  </div>
  
  <div class="row mt-4">
    <div class="col-md-12">
      <h2 class="pb-3">{{ "your-classes-groupal-program" | translate }}</h2>
      <div class="row">
        <div class="col-12 p-2">        
          <a (click)="loadGrupalList('0')" class="link-filter"><span [ngClass]="{'active-filter': show == '0'}">{{ "all-groupal" | translate }}</span> </a> | 
          <a (click)="loadGrupalList('1')" class="link-filter"><span [ngClass]="{'active-filter': show == '1'}">{{ "pending-groupal" | translate }}</span></a> | 
          <a (click)="loadGrupalList('2')" class="link-filter"><span [ngClass]="{'active-filter': show == '2'}">{{ "past-groupal" | translate }}</span></a>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr class="primary">
            <th scope="col">#</th>
            <th scope="col">{{ "date" | translate }}</th>
            <th scope="col">{{ "hour" | translate }}</th>
            <th scope="col">{{ "name" | translate }}</th>
            <th scope="col">{{ "link" | translate }}</th>
            <th scope="col">{{ "subject" | translate }}</th>
            <th scope="col">{{ "free-spaces" | translate }}</th>
            <th scope="col">{{ "students" | translate }}</th>
            <th scope="col">{{ "price" | translate }}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
         
          <tr *ngFor="let class of classes_list">
            <th scope="row">{{ class.id }}</th>
            <td>{{ class.date }}<br><span *ngIf="class.date > today" class="primary bold small"> {{ "pending" | translate }} </span></td>
            <td>{{ class.hour }}</td>
            <td>{{ class.name }}</td>
            <td> <a *ngIf="class.date > today" target="_blank" [href]="'https://' + class.class_url">{{ "link" | translate }}</a></td>
            <td>{{ class.lesson.name }}</td>
            <td>{{ class.freePlaces }}</td>
            <td class="text-center">
              {{ class.students.length }}
            </td>
            <td>{{ class.price | currency:"EUR" }}</td>
            <td>
              <i (click)="editClass(class.id)" class="fas fa-edit"></i>
            </td>
            <td>
              <i (click)="sureRemoveClass(class.id)" class="fas fa-trash-alt"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
